import { LegacyDocumentType } from '@prisma/client';
import * as z from 'zod';

const documentTypeEnumArray: string[] =
  Object.values(LegacyDocumentType);

const documentTypeEnumTupleArray: [string, ...string[]] =
  documentTypeEnumArray as [string, ...string[]];

export const fileSchema = z.object({
  id: z.number().optional(),
  fileName: z.string().trim().optional(),
  fileUrl: z.string().min(1, { message: 'Please upload a file' }).optional(),
  documentType: z.enum(documentTypeEnumTupleArray).optional(),
});
